import { Helmet } from "react-helmet";
import { TabOptions } from "../../types/tabs";
import ComputerIcon from "./../../assets/icons/computer-desktop.svg?react";
import KeyIcon from "./../../assets/icons/key.svg?react";
import CircleStackIcon from "./../../assets/icons/circle-stack.svg?react";

import {
  InstancesBackupsUrl,
  InstancesSshKeysUrl,
  InstancesUrl,
  InstancesVolumesUrl,
} from "../../utils/urls";
import InstancesTab from "../../components/instances/InstancesTab";
import { Outlet } from "react-router-dom";
import InstancesSshKeysTab from "../../components/instances/ssh-keys/InstancesSshKeysTab";
import InstancesVolumesTab from "../../components/instances/volumes/InstancesVolumesTab";
import InstancesBackupsTab from "../../components/instances/backups/InstancesBackupsTab";
import BackupIcon from "../../assets/icons/arrow-up-on-square.svg?react";
import { Flex, Tabs, Typography } from "djuno-design";
import useServiceType from "../../hooks/useServiceType";

export const InstancesPageMenus: TabOptions = [
  {
    label: (
      <div className="flex items-center gap-1">
        <ComputerIcon className="w-3" />
        Instances
      </div>
    ),
    url: InstancesUrl,
    element: <InstancesTab />,
    testId: "1th-tab",
  },
  {
    label: (
      <div className="flex items-center gap-1 ssh-key">
        <KeyIcon className="w-3" />
        SSH keys
      </div>
    ),
    url: InstancesSshKeysUrl,
    element: <InstancesSshKeysTab />,
    testId: "2th-tab",
  },
  {
    label: (
      <div className="flex items-center gap-1 volumes">
        <CircleStackIcon className="w-3" />
        Volumes
      </div>
    ),
    url: InstancesVolumesUrl,
    element: <InstancesVolumesTab />,
    testId: "3th-tab",
  },
  {
    label: (
      <div className="flex items-center gap-1 backups">
        <BackupIcon className="w-3" />
        Backups
      </div>
    ),
    url: InstancesBackupsUrl,
    element: <InstancesBackupsTab />,
    testId: "3th-tab",
  },
  // {
  //   label: (
  //     <div className="flex items-center gap-1">
  //       <ListBulletIcon className="w-3" />
  //       Plans
  //     </div>
  //   ),
  //   url: InstancesPlansUrl,
  //   element: <InstancesPlansTab />,
  // },
];

const InstancesPage = () => {
  const { serviceType } = useServiceType(
    import.meta.env.VITE_INSTANCES_SERVICE_TYPE
  );
  return (
    <>
      <Helmet>
        <title>
          {import.meta.env.VITE_APP_NAME} | {serviceType?.ServiceName || ""}
        </title>
        <meta name="description" content="" />
      </Helmet>
      <Flex items="center" justify="between" className="h-20">
        <Flex items="center" justify="between" className="px-6 flex-1">
          <Typography.Title level={5} className="!mb-0">
            {serviceType?.ServiceName}
          </Typography.Title>
        </Flex>
        <div className="mr-6 w-96"></div>
      </Flex>
      <div className="mx-6">
        <Tabs
          options={InstancesPageMenus.map((o) => ({
            label: o.label,
            url: o.url,
            testId: o.testId,
          }))}
        />
        <div className="py-6">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default InstancesPage;
